import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LanguageFileResolver } from './common/resolvers/language-file-resolver';
import { CommonLanguageFileResolver } from './common/resolvers/common-language-file-resolver';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { pageTitle: 'Home'}
  },
  {
    path: 'franchise-associate-management',
    loadChildren: () => import('./franchise-associate-management/franchise-associate-management.module')
        .then(m => m.FranchiseAssociateManagementModule),
    data: { pageTitle: 'Franchise Associate Management' }
  },
  {
    path: 'client-associate-management/user-management',
    loadChildren: () => import('./client-associate-management/client-associate-management.module')
        .then(m => m.ClientAssociateManagementModule),
    data: { pageTitle: 'Client Associate Management' }
  },
  { path: 'associate-early-account-deactivation',
    loadChildren: () => import('./disabled-user-management/disabled-user-management.module')
      .then(m => m.DisabledUserManagementModule),
    data: { pageTitle: 'Associate Early Account Deactivation'}
  },
  { path: 'user-management',
    loadChildren: () => import('./user-management/user-management.module')
      .then(m => m.UserManagementModule),
    data: { pageTitle: 'User Management'}
  },
  { path: 'user-management/:realm',
    loadChildren: () => import('./user-management/user-management.module')
      .then(m => m.UserManagementModule),
    data: { pageTitle: 'User Management'}
  },
  {
    path: 'profile',
    loadChildren: () => import('./user-management/edit-user/edit-user.module')
      .then(m => m.EditUserModule),
  },
  {
    path: 'managesecurity',
    data: { pageTitle: 'Manage Security', languageComponent: 'manage-security' },
    resolve: {
      languageFile: LanguageFileResolver,
      commonLanguage: CommonLanguageFileResolver
    },
    loadChildren: () => import('./user-management/manage-security/manage-security.module')
      .then(m => m.ManageSecurityModule)
  },
  {
    path: 'newpassword',
    data: { pageTitle: 'New Password', languageComponent: 'new-password' },
    resolve: {
      languageFile: LanguageFileResolver,
      commonLanguage: CommonLanguageFileResolver
    },
    loadChildren: () => import('./user-management/new-password/new-password.module')
      .then(m => m.NewPasswordModule)
  },
  {
    path: 'accountmanagement',
    data: { pageTitle: 'Account Management', languageComponent: 'user-self-service' },
    resolve: {
      languageFile: LanguageFileResolver,
      commonLanguage: CommonLanguageFileResolver
    },
    loadChildren: () => import('./user-management/account-management/account-management.module')
      .then(m => m.AccountManagementModule)
  },
  {
    path: 'userservice',
    data: { pageTitle: 'Account Management', languageComponent: 'user-self-service' },
    resolve: {
      languageFile: LanguageFileResolver,
      commonLanguage: CommonLanguageFileResolver
    },
    loadChildren: () => import('./user-management/user-self-service/user-self-service.module')
      .then(m => m.UserSelfServiceModule)
  },
  {
    path: 'createhelixworkorder',
    data: { pageTitle: 'Submit a Support Ticket', languageComponent: 'user-self-service' },
    resolve: {
      languageFile: LanguageFileResolver,
      commonLanguage: CommonLanguageFileResolver
    },
    loadChildren: () => import('./user-management/helix-workorder/helix-workorder.module')
      .then(m => m.HelixWorkOrderModule)
  },
  {
    path: 'admin-support',
    data: { pageTitle: 'Admin Support' },
    loadChildren: () => import('./admin-support/admin-support.module')
      .then(m => m.AdminSupportModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
